import { render, staticRenderFns } from "./pay-explain.vue?vue&type=template&id=49cae08c&"
import script from "./pay-explain.vue?vue&type=script&lang=js&"
export * from "./pay-explain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports